// @ts-strict-ignore
import React from 'react'
import classNames from 'classnames'
import Image from '../../imgix-img'
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'
import RichText from '../../rich-text-block'
import { useBrand } from '../../helpers/selectors'
import { FsCore } from 'types/fs-core'

interface IProviderLogo {
  id: string
  name: string
  images: {
    [key in FsCore.FSBrand]: string
  }
}

interface IProviderLogoPlatinum {
  name: string
  provider: IProviderLogo[]
  orderOverride: string[]
}

const overrideProviderOrder = (providers: IProviderLogo[], overrideOrder: string[]) => {
  const overridePriority = [...overrideOrder].reverse()
  const reOrderedProviders = [...providers]

  overridePriority.forEach((override) => {
    const indexOfOverride = reOrderedProviders.findIndex((provider) => {
      return provider.name.toLowerCase() === override.toLowerCase()
    })

    if (indexOfOverride !== -1) {
      reOrderedProviders.unshift(reOrderedProviders.splice(indexOfOverride, 1)[0])
    }
  })

  return reOrderedProviders
}

const maxProvidersToDisplay = 10

const ProviderLogoPlatinum: React.FC<IProviderLogoPlatinum> = ({
  provider,
  orderOverride,
  name,
  variant,
  heading,
}) => {
  const orderedProviders = (
    orderOverride ? overrideProviderOrder(provider, orderOverride) : provider
  ).slice(0, maxProvidersToDisplay)

  return (
    <div
      className={variant === 'bordered' ? 'ProviderLogoPlatinum__bordered' : ''}
      id={removeWhitespaceAndSpecialChars(name)}
    >
      {heading && variant === 'bordered' && (
        <RichText {...heading} style={{ textAlign: ['left', 'center'] }} />
      )}
      <div className='ProviderLogoPlatinum'>
        <div
          className={classNames('ProviderLogoPlatinum__photobanner', {
            'ProviderLogoPlatinum__photobanner-bordered': variant === 'bordered',
          })}
        >
          {orderedProviders.map(({ id, name, images }) => {
            const image = (
              <Image
                key={id}
                className={classNames({
                  ProviderLogoPlatinum__image: variant !== 'bordered',
                  'ProviderLogoPlatinum__bordered-image': variant === 'bordered',
                  'ProviderLogoPlatinum__image--ppc': variant === 'ppc',
                })}
                src={images[useBrand()]}
                width={variant === 'cardFinderProviders' ? 84 : variant === 'ppc' ? 150 : 100}
                alt={name}
                critical={false}
              />
            )
            return variant === 'bordered' ? (
              <div className='ProviderLogoPlatinum__image-wrapper'>{image}</div>
            ) : (
              image
            )
          })}
          {orderedProviders.map(({ id, name, images }) => {
            const image = (
              <Image
                key={id}
                className={classNames('ProviderLogoPlatinum__image--desktop', {
                  ProviderLogoPlatinum__image: variant !== 'bordered',
                  'ProviderLogoPlatinum__bordered-image': variant === 'bordered',
                  'ProviderLogoPlatinum__image--ppc': variant === 'ppc',
                })}
                src={images[useBrand()]}
                width={variant === 'cardFinderProviders' ? 84 : variant === 'ppc' ? 150 : 100}
                alt={name}
                critical={variant === 'cardFinderProviders' || variant === 'ppc'}
              />
            )
            return variant === 'bordered' ? (
              <div className='ProviderLogoPlatinum__image-wrapper--desktop'>{image}</div>
            ) : (
              image
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default ProviderLogoPlatinum
